import { FC } from 'react';

import TextBase, { TextProps } from './TextBase';
import { HeadingProps } from './types';

type Heading5FontSize = Extract<TextProps['fontSize'], 14 | 15>;

// Component Definition
const Heading5: FC<HeadingProps<Heading5FontSize>> = ({
  fontColor = 'inherit',
  fontSize = 14,
  fontSizeOverride,
  fontWeight = 700,
  uppercase = false,
  ...props
}) => {
  return (
    <TextBase
      {...props}
      as="h5"
      fontColor={fontColor}
      fontSize={fontSizeOverride ?? fontSize}
      fontWeight={fontWeight}
      uppercase={uppercase}
    />
  );
};

export default Heading5;
